function camelize(s) {
  return s.replace(/([-_][a-z])/gi, function (char) {
    return char.toUpperCase().replace('-', '').replace('_', '');
  });
}
function kebalize(s) {
  return s.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}
export default function normalizeCSSModules(raw) {
  return Object.keys(raw).reduce(function (res, key) {
    var style = raw[key];
    res[kebalize(key)] = style;
    res[camelize(key)] = style;
    res[key] = style;
    return res;
  }, {});
}